import React from "react";
import { Spinner } from "@/assets/svg/Spinner";
import { StudentBar, EmptyStudentBar } from "./StudentBar";
import { useTranslation } from "react-i18next";
import { Student } from "@/__generated__/graphql";
import { NameInput } from "./inputs/NameInput";
import { FirstTimeMessageRecipientInput } from "./inputs/FirstTimeMessageRecipientInput";
import { useBulkMessageProposal } from "@/hooks/useBulkMessageProposal";
import { useOrg } from "@/hooks/useOrg";

export function RiseActionStudents({ actionId }: { actionId?: string }) {
  const { t } = useTranslation();
  const { org } = useOrg();
  const { loading: proposalLoading, students } = useBulkMessageProposal({
    orgId: org?.id,
    filters: {
      studentList: {
        rise: {
          actionDetails: {
            riseUserActionId: actionId,
          },
        },
      },
    },
  });

  return (
    <div>
      <div className="grid grid-cols-2 gap-6">
        <NameInput />
        <FirstTimeMessageRecipientInput disabled={true} />
      </div>
      <div className="mt-4">
        {proposalLoading ? (
          <section className="flex h-60 flex-col items-center justify-center gap-6 rounded bg-gray-50 p-8 shadow-sm dark:bg-input">
            <Spinner className="size-4 fill-white text-black/50" />
            <p className="text-sm font-medium text-gray-700">
              {t("global.loading")}
            </p>
          </section>
        ) : (
          <RiseActionStudentsPreview students={students} />
        )}
      </div>
    </div>
  );
}

interface RiseActionStudentsPreviewProps {
  students: Student[];
}

export function RiseActionStudentsPreview({
  students,
}: RiseActionStudentsPreviewProps) {
  const { t } = useTranslation();

  if (!students.length) {
    return <NoneFound />;
  }

  return (
    <section
      className="flex flex-col gap-6 rounded bg-gray-50 p-8 shadow-sm dark:bg-input"
      data-testid="csv-upload-results"
    >
      <div className="flex items-center gap-4">
        <StudentBar students={students} />
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm text-foreground/40">
          {t("bulkMessaging.basicInformation.riseAction.previewDesc")}
        </p>
      </div>
    </section>
  );
}

function NoneFound() {
  return (
    <section className="flex h-60 flex-col gap-6 rounded bg-gray-50 p-8 shadow-sm dark:bg-input">
      <EmptyStudentBar />
    </section>
  );
}
